import { render, staticRenderFns } from "./DeviceCard.vue?vue&type=template&id=7f22d71e&scoped=true"
import script from "./DeviceCard.vue?vue&type=script&lang=js"
export * from "./DeviceCard.vue?vue&type=script&lang=js"
import style0 from "./DeviceCard.vue?vue&type=style&index=0&id=7f22d71e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f22d71e",
  null
  
)

export default component.exports